import { HTMLAttributes } from "react"
import Form from "next/form"
import Image from "next/image"
import { Button } from "@heroui/button"
import { Input, Textarea } from "@heroui/input"
import { cn } from "@heroui/react"

import SendIcon from "@/public/icons/send.png"

export const SearchInput = ({
  defaultValue,
  classNames,
  compact = false,
}: {
  compact?: boolean
  defaultValue?: string
  classNames?: {
    base?: string
    wrapper?: string
  }
} & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn("relative h-auto w-full sm:h-[70px]", classNames?.base)}>
      <div
        className={cn(
          "h-full bg-[linear-gradient(91.64deg,#0F9E4F_19.86%,#C0FF40_42.57%,#4797FF_66.68%)] shadow-[-77px_368px_105px_0px_rgba(15,158,79,0.00),-49px_235px_96px_0px_rgba(15,158,79,0.01),-28px_132px_81px_0px_rgba(15,158,79,0.05),-12px_59px_60px_0px_rgba(15,158,79,0.09),-3px_15px_33px_0px_rgba(15,158,79,0.10)]",
          "rounded-xl",
          compact ? "p-px" : "p-0.5",
          classNames?.wrapper
        )}
      >
        <div
          className={cn(
            "flex h-full flex-col items-start gap-1 bg-white sm:flex-row sm:items-center sm:gap-2",
            compact
              ? "rounded-[calc(0.75rem-1px)] sm:px-3 sm:py-0"
              : "rounded-[calc(0.75rem-0.125rem)] p-3 sm:px-6 sm:py-4",
            classNames?.wrapper
          )}
        >
          <Form
            action="/search"
            prefetch={false}
            className="hidden w-full sm:block"
          >
            <Input
              startContent={
                <span
                  className={cn(
                    "flex-none text-base leading-[normal]",
                    compact
                      ? "sm:text-base sm:font-medium"
                      : "sm:text-xl sm:font-bold"
                  )}
                >
                  Snap it/
                </span>
              }
              endContent={
                <Button
                  variant="light"
                  isIconOnly
                  type="submit"
                  autoFocus
                  className={cn(compact && "h-6 w-auto min-w-0")}
                  disableRipple
                >
                  <Image
                    src={SendIcon}
                    alt="send-icon"
                    className="h-full w-auto"
                    unoptimized
                    priority
                  />
                </Button>
              }
              name="q"
              defaultValue={defaultValue}
              variant="bordered"
              placeholder="Paste a product URL or search a product name"
              classNames={{
                input: "h-auto text-md",
                inputWrapper:
                  "bg-transparent border-none shadow-none h-auto min-h-0 p-0",
              }}
            />
          </Form>
          <Form
            action="/search"
            prefetch={false}
            className="flex w-full flex-col gap-3 sm:hidden"
          >
            <Textarea
              startContent={
                <span
                  className={cn(
                    "flex-none text-base leading-[normal]",
                    compact
                      ? "sm:text-base sm:font-medium"
                      : "sm:text-xl sm:font-bold"
                  )}
                >
                  Snap it/
                </span>
              }
              endContent={
                <Button
                  variant="shadow"
                  color="primary"
                  className={cn("w-full rounded-full text-white")}
                  type="submit"
                  autoFocus
                  disableRipple
                >
                  Snap it
                </Button>
              }
              name="q"
              defaultValue={defaultValue}
              variant="bordered"
              placeholder="Paste a product URL or search a product name"
              classNames={{
                input: "h-auto text-sm !p-0 !ps-0",
                inputWrapper:
                  "bg-transparent border-none shadow-none h-auto min-h-0 p-0",
                innerWrapper: "flex-col gap-1",
              }}
              rows={2}
              maxRows={2}
            />
          </Form>
        </div>
      </div>
    </div>
  )
}
